<template>
	<div>
		<div v-bind="ADAattr('sr-only')">Please log in or continue as a guest</div>
		<div class="co-login-sections">
			<v-flex class="pa-0">
				<v-card
						v-if="asiForm.form && asi_mode"
						align-start
						flat
						class="ma-3 pa-0"
				>
					<v-card-text>
						<div class="heading" v-bind="ADAattr('focus')">Log In</div>
						<div class="co-login-asi-prompt" v-bind="ADAattr('focus')">
							{{ getASILoginPrompt() }}
						</div>
						<div class="co-login-asi-block" v-html="asiForm.form"></div>
						<div class="co-login-alt-mode">
							or,
							<a
								href="#"
								@click.prevent="asi_mode = false"
								v-bind="ADAattr('button', 'Log in with a textbookx account')"
							>
								Log In
							</a> with a TextbookX account
						</div>
					</v-card-text>
				</v-card>
				<v-card
						v-else
						align-start
						flat
						class="ma-3 pa-0"
				>
					<v-card-text>
						<div class="heading" v-bind="ADAattr('focus')">Log In</div>

						<v-form
								ref="login_form"
								@submit.prevent="login"
						>

							<v-text-field
									v-model="username"
									label="Email or Username"
									class="co-text-field"
									:rules="rule_required"
							></v-text-field>

							<v-text-field
									v-model="password"
									type="password"
									label="Password"
									class="co-text-field"
									:rules="rule_required"
							></v-text-field>

							<div v-if="$globs['captcha_settings']['show_login_captcha'] || show_captcha" class="co-captcha-panel my-3">
								<vue-recaptcha
										ref="recaptcha"
										@verify="onCaptchaVerify"
										:sitekey="$globs['captcha_settings']['public_key']"
										size="normal"
								>
								</vue-recaptcha>
							</div>

							<v-btn
									block
									type="submit"
									:disabled="($globs['captcha_settings']['show_login_captcha'] || show_captcha) && !captcha_response"
							>
								Log In
							</v-btn>

						</v-form>

						<div class="co-login-alt-mode" v-if="asiForm.form">
							or,
							<a
								href="#"
								@click.prevent="asi_mode = true"
								v-bind="ADAattr('button', 'Log in with your school credentials')"
							>
								Log In
							</a> with your school credentials
						</div>

					</v-card-text>
					<v-card-text>
						<v-divider v-bind="ADAattr('hidden')"></v-divider>

						<p>
							<a href="/account/forgot.php">Forgot password?</a>
						</p>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex class="co-login-sections-separator ma-3 pa-0">
				<v-card align-start flat class="px-3">
					<v-card-text>
						<h3 v-bind="ADAattr('focus')">Continue as a Guest</h3>

						<div class="co-login-asi-prompt">Checkout without an account</div>

						<v-form
								ref="guest_form"
								@submit.prevent="submit"
						>
							<v-text-field
									type="email"
									label="Email Address"
									v-model="email"
                  aria-autocomplete="false"
									:rules="rule_email"
									class="co-text-field"
							></v-text-field>

							<v-btn block @click="submit" v-bind="ADAattr('label', 'Continue as a guest')">Continue</v-btn>
						</v-form>

						<p class="mx-0 mt-3 mb-0">
							If you're using a {{$globs['voucher_name'].toLowerCase()}} or gift code, sign in or <a href="/account/register.php">create an account</a>
						</p>
					</v-card-text>
				</v-card>
			</v-flex>
		</div>
	</div>
</template>

<script>
	import {getASILoginPrompt} from './../includes/SpecialCasesHandles';
	import Axios from 'axios';
	import {EventBus} from './../includes/EventBus';
	import VueRecaptcha from 'vue-recaptcha';

	export default {
		name: "Login",

		components: {
			VueRecaptcha,
		},

		props: {
			step: {
				type: Number,
			},
			asiForm: {
				type: Object,
				default: null,
			},
		},

		data() {
			return {
				email: '',
				username: '',
				password: '',

				rule_required: [
					v => !!v || 'Field is required',
				],
				rule_email: [
					value => {
						const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						return (!!value.trim && !!value.trim() && pattern.test(value)) || 'Invalid e-mail.';
					},
				],

				asi_mode: false,
				show_captcha: false,
				captcha_response: null,
			};
		},

		methods: {
			getASILoginPrompt() {
				return getASILoginPrompt(
					this.$globs['asi_login_form']['label'],
					this.$globs['financial_aid_information']['enabled'],
					this.$globs['institute_name'],
					this.$globs['financial_aid_name']
				);
			},

			onCaptchaVerify(response) {
				this.captcha_response = response;
			},

			resetCaptcha(show) {
				this.captcha_response = null;
				this.show_captcha = show;
				if (this.$refs['recaptcha']) {
					this.$refs['recaptcha'].reset();
				}
			},

			submit() {
				const self = this;

				if (!self.$refs.guest_form.validate()) {
					return;
				}

				Axios.post("/sc/rest/index.php/has_account/", {email: self.email}).then(({data}) => {
					if (data['has_account']) {
						EventBus.$emit('show-message', {
							msg: "The email address you entered is already registered on our system. Please try entering a different email address.",
							severity: 2,
						});

						return;
					}

					self.$emit('submit', {
						success: true,
						data: {
							email: self.email,
						},
					});

				});

				return false;
			},

			login() {
					const self = this;
					if (!this.$refs.login_form.validate()) {
						return false;
					}
					Axios.post("/sc/rest/index.php/login_user/", {
						captcha_response: this.captcha_response,
						username: this.username,
						password: this.password
					}).then(({data}) => {
						this.resetCaptcha(data['show_captcha']);
						if(data['logged_in'] == false){

							if(data['message'] == 'suspended'){
								EventBus.$emit('show-message', {
									msg: "Your account has been suspended.\n" +
											"This account has been suspended by our quality assurance team.",
									severity: 2,
								});
								return;
							}
							if (data['message'] === 'failed') {
								EventBus.$emit('show-message', {
									msg: "Sorry, your login failed. Please try again.",
									severity: 2,
								});
							} else {
								EventBus.$emit('show-message', {
									msg: data['message'],
									severity: 2,
								});
							}
							return;
						}
						if(data['message'] === 'sc_merged') {
							window.location.href = '/sc';
							return;
						}

						self.$emit('login', {
							success: true,
							data: {
								loggedIn: data['logged_in'],
							},
						});
					});
					return true;
			}
		},

		computed: {},

		watch: {
			asiForm: {
				immediate: true,
				handler(value) {
					this.asi_mode = !!value;
				},
			},
		}
	};
</script>

<style scoped lang="less">
	.co-login-sections {

		display: flex;
		flex-direction: column;
		@media screen and (min-width: 600px) {
			flex-direction: row;
			& > div {
				flex: 1;
			}
		}

		.heading {
			font-size: 17px;
      font-weight: bold;
		}

		@media screen and (min-width: 600px) {
			.co-login-sections-separator {
				border-left: 1px solid #DDDDDD;
				position: relative;

				&:after {
					content: "OR";
					display: block;
					position: absolute;
					top: 50%;
					left: -16px;
					margin-top: -16px;
					background-color: #fff;
					width: 32px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					vertical-align: middle;
				}
			}
		}

		.co-login-asi-prompt {
			padding: 10px 0;
		}

		.co-login-asi-block {
			margin-top: 20px;
			padding: 30px 0;
			border: 1px dashed #ccc;
			background-color: #f7f7f7;
		}

		.co-login-container {
		}

		.co-login-alt-mode {
			margin-top: 20px;
		}

		.co-captcha-panel {
			transform-origin: 0 0;

			@media screen and (max-width: 600px) {
				transform: scale(0.79);
				max-width: 240px;
			}

			@media screen and (min-width: 600px) {
				transform: scale(0.6);
				max-width: 150px;
			}

			@media screen and (min-width: 960px) {
				transform: scale(0.87);
				max-width: 260px;
			}
		}
	}
</style>